/**
 * GraphQL mutation for submitting feedback on a moderation case
 */

import { gql } from '@apollo/client';

export const SUBMIT_CASE_FEEDBACK = gql`
  mutation SubmitCaseFeedback($input: CaseFeedbackInput!) {
    submitCaseFeedback(input: $input) {
      id
      communityId
      topicName
      subjectId
      caseId
      pk
      timestamp
      feedbackSource {
        type
        id
      }
      feedbackLabels
      feedbackComment
      createdAt
      createdBy
      lastModifiedAt
      lastModifiedBy
    }
  }
`;
